import { createContext, useContext, useEffect } from 'react';

// Lets a deeply-nested view (e.g. a question shown inside a classroom)
// hide the top navigation bar while it is mounted. The boolean state lives
// at the app root; consumers call setNavHidden(true/false) on mount/unmount.
// setCallNavHidden is a separate flag owned by the live call on phones, so a
// question step ending inside the call (setNavHidden(false)) cannot bring the
// nav back mid-call.
// askAddyHidden hides only the Ask Addy launcher, while the child's own Addy is on
// a working screen (lesson, quiz, Core Skills) and the launcher would cover him.
export const NavVisibilityContext = createContext({
  navHidden: false,
  setNavHidden: () => {},
  setCallNavHidden: () => {},
  askAddyHidden: false,
  hideAskAddy: () => {},
});

export const useNavVisibility = () => useContext(NavVisibilityContext);

/** Hides the Ask Addy launcher while `active` and this component is mounted. Counted, so screens can overlap. */
export function useHideAskAddy(active = true) {
  const { hideAskAddy } = useNavVisibility();
  useEffect(() => {
    if (!active) return undefined;
    hideAskAddy(true);
    return () => hideAskAddy(false);
  }, [active, hideAskAddy]);
}
